import Store from '@/store/computed/storeHelpers'
export default {
  computed: {
    defaultHeaders: Store.getSet({
      store: 'shared',
      prop: 'allocationDefaultHeaders'
    })
  },
  data() {
    return {
      allPossibleHeaders: [
        {
          text: 'ID',
          align: 'left',
          value: 'id',
          type: 'text'
        },
        {
          text: 'Date',
          align: 'left',
          value: 'date',
          type: 'date'
        },
        {
          text: 'Details',
          align: 'left',
          value: 'details',
          type: 'text'
        },
        {
          text: 'Project',
          align: 'left',
          value: 'site.project.name',
          type: 'text'
        },
        {
          text: 'Site',
          align: 'left',
          value: 'site.name',
          type: 'text'
        },
        {
          text: 'Tip',
          align: 'left',
          value: 'tip.name',
          type: 'text'
        },
        {
          text: 'Spoil',
          align: 'left',
          value: 'spoil.name',
          type: 'text'
        },
        {
          text: 'Sub-contractor',
          align: 'left',
          value: 'vehicle.contractor.name',
          type: 'text'
        },
        {
          text: 'Vehicle',
          align: 'left',
          value: 'vehicle.name',
          type: 'text'
        },
        {
          text: 'Vehicle Type',
          align: 'left',
          value: 'vehicle.vehicleType.name',
          type: 'text'
        },
        {
          text: 'Driver',
          align: 'left',
          value: 'driver.name',
          type: 'text'
        },
        {
          text: 'Docket ID',
          align: 'left',
          value: 'docket.externalRef',
          type: 'text'
        },
        {
          text: 'Matched Docket',
          align: 'left',
          value: 'prelimDocket.externalRef',
          type: 'text'
        },
        {
          text: 'Status',
          align: 'left',
          value: 'status',
          type: 'text'
        },
        {
          text: 'Day / Night',
          align: 'center',
          value: 'day',
          type: 'dayBool'
        },
        {
          text: 'Entered By',
          align: 'left',
          value: 'createdBy.name',
          type: 'text'
        },
        {
          text: 'Billing Period',
          align: 'left',
          value: 'billingPeriod',
          type: 'text'
        }
      ]
    }
  }
}
